<template>
  <svg
    :class="className"
    fill="none"
    :height="height"
    viewBox="0 0 60 15"
    :width="width"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g>
      <path d="M44.1371 2.84245V0.153721H38.0998V14.8654H44.1371V12.1772H40.7936V8.85449H44.1371V6.16521H40.7936V2.84245H44.1371ZM58.0097 14.1165C58.0097 13.7133 58.2965 13.3671 58.7547 13.3671C59.2135 13.3671 59.5002 13.6942 59.5002 14.1165C59.5002 14.5197 59.2135 14.866 58.7547 14.866C58.2965 14.866 58.0097 14.5388 58.0097 14.1165ZM59.3283 14.1165C59.3283 13.8091 59.0986 13.5405 58.7547 13.5405C58.4108 13.5405 58.1817 13.8091 58.1817 14.1165C58.1817 14.424 58.4108 14.6926 58.7547 14.6926C59.0986 14.6926 59.3283 14.4431 59.3283 14.1165ZM58.4304 14.4814V13.7516H58.7357C58.9076 13.7516 59.0986 13.7899 59.0986 13.9628C59.0986 14.0777 59.0224 14.1165 58.8886 14.1357V14.1931H59.0224C59.0796 14.1931 59.0986 14.2128 59.0986 14.2697V14.4814H58.9457V14.2511H58.6023V14.4814H58.4304ZM58.5827 14.0974H58.7357C58.8695 14.0974 58.9457 14.0974 58.9457 14.0011C58.9457 13.9054 58.8695 13.9054 58.7357 13.9054H58.5827V14.0968V14.0974ZM52.3163 0.153721H45.2473V2.84245H47.0812V14.8654H49.775V2.84245H51.3041L52.3163 0.153721ZM59.4812 0.153721H53.4439L52.4312 2.84245H54.6858V14.8654H57.3986V2.84245H59.4812V0.153721ZM37.2035 14.8654L33.7844 7.50985L37.2035 0.153173H34.3188L30.8985 7.5093L34.3188 14.8649H37.2035V14.8654ZM24.4395 8.85394V12.1767H22.4716V2.84245H24.4395V6.16521H27.1142V2.20897C27.1142 1.62312 26.8827 1.06126 26.4705 0.646993C26.0584 0.232731 25.4995 6.15688e-07 24.9167 6.15688e-07H21.9558C21.6697 -0.00021511 21.3863 0.056261 21.122 0.166199C20.8576 0.276138 20.6174 0.437382 20.4151 0.640711C20.2128 0.84404 20.0523 1.08547 19.9429 1.35118C19.8335 1.6169 19.7772 1.90169 19.7773 2.18928V12.791C19.7773 13.3769 20.0089 13.9387 20.421 14.353C20.8331 14.7673 21.392 15 21.9748 15H24.9363C25.519 14.9999 26.0778 14.7671 26.4898 14.3528C26.9018 13.9386 27.1332 13.3768 27.1332 12.791V8.85394H24.4395Z" :fill="fill"/>
      <path d="M28.2465 0.164691V14.8764H30.9403V0.164691H28.2465ZM18.6312 2.84357V0.154844H12.5939V14.8666H18.6312V12.1784H15.2876V8.85561H18.6312V6.16633H15.2876V2.84357H18.6312ZM2.96545 7.41469H0.86377L2.48764 8.68274L1.64686 10.9103L3.74854 9.52738V5.302L2.9649 7.41469H2.96545ZM11.4489 5.64773V2.24839C11.4477 1.69345 11.228 1.16156 10.8377 0.769112C10.4474 0.37666 9.9183 0.155598 9.36626 0.154297H3.74909V5.302L4.55123 7.41414H6.6344L5.02903 8.6822L5.86981 10.9103L3.74909 9.52738V14.8666H9.30857C9.58974 14.8671 9.86824 14.8118 10.1281 14.7039C10.388 14.5959 10.6241 14.4375 10.8229 14.2377C11.0218 14.0379 11.1794 13.8006 11.2868 13.5394C11.3942 13.2782 11.4493 12.9982 11.4489 12.7156V9.35452C11.4489 8.50933 10.8944 7.74073 10.0922 7.49128C10.8944 7.26152 11.4483 6.51207 11.4483 5.64773H11.4489ZM9.04137 11.314C9.04137 11.8709 8.58262 12.3315 8.02917 12.3315H6.44285V8.72104H8.02863C8.58262 8.72104 9.04083 9.1822 9.04083 9.73909V11.3146L9.04137 11.314ZM9.04137 5.14883C9.04137 5.70572 8.58262 6.16688 8.02917 6.16688H6.44285V2.709H8.02863C8.58262 2.709 9.04083 3.17016 9.04083 3.72705V5.14883H9.04137Z" :fill="fill"/>
    </g>
  </svg>
</template>

<script>
export default {
  name: 'Beckett',
  props: {
    width: {
      type: String,
      required: false,
      default: '100%'
    },
    height: {
      type: String,
      required: false,
      default: '100%'
    },
    className: {
      type: String,
      required: false,
      default: ''
    },
    fill: {
      type: String,
      required: false,
      default: '#000'
    },
  },
};

</script>
